/** @jsx h */
import { h, Fragment } from "preact";
import { useContext, useState } from "preact/hooks";
import { renderPreact } from "../lib/render-preact";
import PageContext from "./PageContext";
import { translate, t } from "../I18n";
import Alert from "./Alert";
import PreactTooltip from "./PreactTooltip";
const searchFormId = "section-restaurants";
const stickyHeaderSelector = ".js-sticky-header-element.is-affixed";
let deliveryAddress = ""; // TODO: Move to localStorage (share with cart and other delivery components)
const getAddressSectionClass = (hasOverflowSection = false) => {
    return hasOverflowSection === true
        ? "m-restaurants__card--overflow-section"
        : "m-restaurants__card--regular-section";
};
// Scroll to the form if it's above the viewport.
const scrollToForm = (hasOverflowSection = false) => {
    const searchSection = document.getElementById(searchFormId);
    if (searchSection instanceof HTMLElement) {
        const stickyHeader = document.querySelector(stickyHeaderSelector);
        const overflowOffset = hasOverflowSection === true ? 90 : 0; // This value should match the CSS `margin-top' for `m-restaurants__card--overflow-section' element.
        const stickyHeaderOffset = stickyHeader instanceof HTMLElement ? stickyHeader.offsetHeight : 0;
        const scrollMarginTop = stickyHeaderOffset + overflowOffset + 15 + "px";
        const viewportOffset = searchSection.getBoundingClientRect().top;
        searchSection.style.scrollMarginTop = scrollMarginTop;
        if (viewportOffset < parseInt(scrollMarginTop)) {
            searchSection.scrollIntoView({
                behavior: "smooth",
            });
        }
    }
};
// Sort the list based on the 'isSelected' property (true value come first)
const sortRestaurants = (list) => {
    return list.sort((a, b) => {
        if (a.isSelected === b.isSelected) {
            return 0;
        }
        return a.isSelected ? -1 : 1;
    });
};
// Mark current restaurant as selected.
const updateRestaurantsWithLatest = (restaurants) => {
    if (typeof window === "undefined")
        return restaurants;
    const currentRestaurantSlug = window.localStorage.getItem("currentRestaurant");
    if (!currentRestaurantSlug)
        return restaurants;
    restaurants = restaurants.map((restaurant) => ({
        ...restaurant,
        isSelected: restaurant.slug === currentRestaurantSlug,
    }));
    return sortRestaurants(restaurants);
};
// TODO: real restaurants data
const restaurants = updateRestaurantsWithLatest([
    {
        name: "Nazwa restauracji 1",
        slug: "venezia",
        address: "ul. Wolności 123, Warszawa",
        phone: "515 202 341",
        email: "contact@restaumatic.com",
        deliveryTypes: "Dostawa, odbiór osobisty",
        menuLink: "https://venezia.dev.manca.ro/restauracja/venezia",
        isWithinArea: true,
        isSelected: false,
        openingHours: "Pon.-Pt.: 12:00 - 21:00\nSob.: 12:00 - 23:00\nNdz.: 12:00 - 21:00",
        deliveryCost: "20 zł",
        minOrderValue: "80 zł",
        freeTreshold: "60 zł",
        id: "1",
    },
    {
        name: "Nazwa restauracji 2",
        slug: "venezia-2",
        address: "ul. Wolności 123, Warszawa",
        phone: "515 202 341",
        email: "contact@restaumatic.com",
        deliveryTypes: "Dostawa, odbiór osobisty",
        menuLink: "https://venezia.dev.manca.ro/restauracja/venezia",
        isWithinArea: true,
        isSelected: false,
        openingHours: "Pon.-Pt.: 12:00 - 21:00\nSob.: 12:00 - 23:00\nNdz.: 12:00 - 21:00",
        deliveryCost: "20 zł",
        minOrderValue: "80 zł",
        freeTreshold: null,
        id: "2",
    },
    {
        name: "Nazwa restauracji 3",
        slug: "venezia-3",
        address: "ul. Wolności 123, Warszawa",
        phone: "515 202 341",
        email: "contact@restaumatic.com",
        deliveryTypes: "Dostawa, odbiór osobisty",
        menuLink: "https://venezia.dev.manca.ro/restauracja/venezia",
        isWithinArea: false,
        isSelected: false,
        openingHours: "Pon.-Pt.: 12:00 - 21:00\nSob.: 12:00 - 23:00\nNdz.: 12:00 - 21:00",
        deliveryCost: "20 zł",
        minOrderValue: "80 zł",
        freeTreshold: "60 zł",
        id: "3",
    },
    {
        name: "Nazwa restauracji 4",
        slug: "venezia-4",
        address: "ul. Wolności 123, Warszawa",
        phone: "515 202 341",
        email: "contact@restaumatic.com",
        deliveryTypes: "Dostawa, odbiór osobisty",
        menuLink: "https://venezia.dev.manca.ro/restauracja/venezia",
        isWithinArea: false,
        isSelected: false,
        openingHours: "Pon.-Pt.: 12:00 - 21:00\nSob.: 12:00 - 23:00\nNdz.: 12:00 - 21:00",
        deliveryCost: "20 zł",
        minOrderValue: "80 zł",
        freeTreshold: "60 zł",
        id: "4",
    },
    {
        name: "Nazwa restauracji 5",
        slug: "venezia-0",
        address: "ul. Wolności 123, Warszawa",
        phone: "515 202 341",
        email: "contact@restaumatic.com",
        deliveryTypes: "Dostawa, odbiór osobisty",
        menuLink: "https://venezia.dev.manca.ro/restauracja/venezia",
        isWithinArea: false,
        isSelected: false,
        openingHours: "Pon.-Pt.: 12:00 - 21:00\nSob.: 12:00 - 23:00\nNdz.: 12:00 - 21:00",
        deliveryCost: "20 zł",
        minOrderValue: "80 zł",
        freeTreshold: "60 zł",
        id: "5",
    },
    {
        name: "Nazwa restauracji 6",
        slug: "venezia-0",
        address: "ul. Wolności 123, Warszawa",
        phone: "515 202 341",
        email: "contact@restaumatic.com",
        deliveryTypes: "Dostawa, odbiór osobisty",
        menuLink: "https://venezia.dev.manca.ro/restauracja/venezia",
        isWithinArea: false,
        isSelected: false,
        openingHours: "Pon.-Pt.: 12:00 - 21:00\nSob.: 12:00 - 23:00\nNdz.: 12:00 - 21:00",
        deliveryCost: "20 zł",
        minOrderValue: "80 zł",
        freeTreshold: "60 zł",
        id: "6",
    },
    {
        name: "Nazwa restauracji 7",
        slug: "venezia-0",
        address: "ul. Wolności 123, Warszawa",
        phone: "515 202 341",
        email: "contact@restaumatic.com",
        deliveryTypes: "Dostawa, odbiór osobisty",
        menuLink: "https://venezia.dev.manca.ro/restauracja/venezia",
        isWithinArea: false,
        isSelected: false,
        openingHours: "Pon.-Pt.: 12:00 - 21:00\nSob.: 12:00 - 23:00\nNdz.: 12:00 - 21:00",
        deliveryCost: "20 zł",
        minOrderValue: "80 zł",
        freeTreshold: "60 zł",
        id: "7",
    },
]);
function RestaurantSelection(props) {
    const { hasOverflowSection, titleExtraClass, cardTitleExtraClass } = props;
    const settings = useContext(PageContext);
    const [isRestaurantInAreaFound, setIsRestaurantInAreaFound] = useState(false);
    const [isSearchingStart, setIsSearchingStart] = useState(false);
    const [isFormVisible, setIsFormVisible] = useState(true);
    const deliveringRestaurants = restaurants.filter((item) => item.isWithinArea);
    const otherRestaurants = restaurants.filter((item) => !item.isWithinArea);
    const onEdit = () => {
        setIsFormVisible(true);
        scrollToForm(hasOverflowSection);
    };
    return (h("div", { className: "m-restaurants", "aria-live": "polite" },
        h("article", { className: "u-base-spacing-b" },
            isFormVisible && (h(AddressForm, { titleExtraClass: titleExtraClass, hasOverflowSection: hasOverflowSection, onSubmit: () => {
                    setIsRestaurantInAreaFound(true);
                    setIsFormVisible(false);
                    setIsSearchingStart(true);
                    deliveryAddress = "Radzymińska 244, Warszawa";
                } })),
            isRestaurantInAreaFound && !isFormVisible && (h(FilledAddressBox, { titleExtraClass: titleExtraClass, hasOverflowSection: hasOverflowSection, selectedDeliveryType: "Dostawa", onEdit: onEdit }))),
        !isRestaurantInAreaFound && !isSearchingStart && (h(RestaurantList, { title: translate(t.restaurants.select.header_all), list: restaurants, titleExtraClass: titleExtraClass, cardTitleExtraClass: cardTitleExtraClass })),
        isRestaurantInAreaFound && isSearchingStart && (h(Fragment, null,
            h(RestaurantList, { title: translate(t.restaurants.select.header_deliver), list: deliveringRestaurants, titleExtraClass: titleExtraClass, cardTitleExtraClass: cardTitleExtraClass, doesRestaurantDeliver: true, onEdit: !isFormVisible ? onEdit : undefined }),
            h(RestaurantList, { title: translate(t.restaurants.select.header_others), list: otherRestaurants, titleExtraClass: titleExtraClass, cardTitleExtraClass: cardTitleExtraClass, doesRestaurantDeliver: false, onEdit: onEdit })))));
}
function AddressForm(props) {
    const { titleExtraClass, hasOverflowSection, onSubmit } = props;
    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit();
    };
    const formExtraClass = getAddressSectionClass(hasOverflowSection);
    return (h("div", { className: `m-restaurants__card ${formExtraClass}` },
        h("h2", { className: `m-restaurants__heading ${titleExtraClass}`, id: "restaurant-selection-form-heading" }, translate(t.restaurants.select.title_find)),
        h("form", { className: "m-restaurants__form", "aria-controls": "restaurant-selection-list", onSubmit: handleSubmit },
            h("div", { className: "m-restaurants__field" },
                h("input", { type: "text", name: "restaurant-selection-input-address", className: "form-control", id: "restaurant-selection-input-address", autocomplete: "shipping street-address", placeholder: "Wpisz sw\u00F3j dok\u0142adny adres", "aria-labelledby": "restaurant-selection-form-heading" }),
                h("button", { type: "button", className: "m-restaurants__field-locate btn btn-link u-p0" },
                    h("span", { title: translate(t.delivery_method.locate_me), className: "icon-target u-font-size-120p" }))),
            h("button", { type: "submit", className: "btn btn-primary" }, translate(t.restaurants.select.find_restaurant))),
        h(Alert, { type: "danger", message: translate(t.delivery.geocoding_error) })));
}
// TODO: To add in MVP (current version in based on existing layout from `selectRestaurant.purs`)
function FilledAddressBox(props) {
    const { hasOverflowSection, selectedDeliveryType, titleExtraClass, onEdit } = props;
    const formExtraClass = getAddressSectionClass(hasOverflowSection);
    const editBtnClass = hasOverflowSection === true ? "u-cap-first-letter pull-right" : "";
    const editBtnText = hasOverflowSection === true
        ? translate(t.restaurants.select.button_change)
        : "(" + translate(t.restaurants.select.button_change) + ")";
    return (h("div", { className: `m-restaurants__card ${formExtraClass}` },
        h("h2", { className: `m-restaurants__heading ${titleExtraClass}` }, translate(t.restaurants.select.your_address)),
        h("div", { className: "d-flex" },
            h("span", { className: "m-restaurants__card-icon m-restaurants__card-icon--primary icon-location icon-base", "aria-hidden": "true" }),
            h("div", { className: "u-flex-grow" },
                h("b", null, selectedDeliveryType),
                h("br", null),
                h("span", null,
                    deliveryAddress,
                    "\u00A0"),
                h("button", { type: "button", className: `btn btn-link u-p0 ${editBtnClass}`, onClick: onEdit }, editBtnText)))));
}
function RestaurantList(props) {
    const { title, list, titleExtraClass, cardTitleExtraClass, doesRestaurantDeliver, onEdit, } = props;
    return (h("article", { className: "u-base-spacing-b" },
        h("h2", { className: `m-restaurants__heading ${titleExtraClass}`, id: "restaurant-selection-list-heading" },
            h("span", null,
                title,
                " "),
            doesRestaurantDeliver !== false && h("span", null, deliveryAddress)),
        h("ul", { className: "list-unstyled row row--flex row--vertical-gutter", id: "restaurant-selection-list", "aria-labelledby": "restaurant-selection-list-heading" }, list.map((item, index) => (h(RestaurantCard, { restaurant: item, titleExtraClass: cardTitleExtraClass, doesRestaurantDeliver: doesRestaurantDeliver, onEdit: onEdit }))))));
}
function RestaurantCard(props) {
    const { restaurant, doesRestaurantDeliver, titleExtraClass, onEdit } = props;
    const openingHours = restaurant.openingHours.split("\n");
    const freeTresholdString = restaurant.freeTreshold
        ? ", " +
            translate(t.theme_defaults.delivery.info.free_treshold) +
            restaurant.freeTreshold
        : "";
    return (h("li", { className: "col-sm-6 col-md-4" },
        h("div", { class: `m-restaurants__card ${restaurant.isSelected ? "m-restaurants__card--selected" : ""}` },
            h("h3", { className: `m-restaurants__card-title ${titleExtraClass}` }, restaurant.name),
            h("ul", { className: "u-list-unstyled u-flex-grow" },
                h("li", { className: "d-flex u-my3" }, restaurant.address),
                h("li", { className: "d-flex u-my3" },
                    h("span", { className: "m-restaurants__card-icon icon-time icon-base", "aria-hidden": "true" }),
                    h("div", null, openingHours.map((line, index) => (h(Fragment, { key: index },
                        line,
                        h("br", null)))))),
                h("li", { className: "d-flex u-my3" },
                    h("span", { className: "m-restaurants__card-icon icon-phone icon-base", "aria-hidden": "true" }),
                    h("a", { href: `tel:${restaurant.phone}`, className: "u-link-unstyled" }, restaurant.phone)),
                h("li", { className: "d-flex u-my3" },
                    h("span", { className: "m-restaurants__card-icon icon-mail icon-base", "aria-hidden": "true" }),
                    h("a", { href: `mailto:${restaurant.email}`, className: "u-link-unstyled u-text-ellipsis" }, restaurant.email)),
                h("li", { className: "d-flex u-my3" },
                    h("span", { className: "m-restaurants__card-icon icon-shopping-cart icon-base", "aria-hidden": "true" }),
                    h("span", null, restaurant.deliveryTypes)),
                doesRestaurantDeliver === true && (h("li", { className: "d-flex u-my3" },
                    h("span", { className: "m-restaurants__card-icon icon-truck icon-base", "aria-hidden": "true" }),
                    h("span", null,
                        restaurant.deliveryCost,
                        " (min. ",
                        restaurant.minOrderValue,
                        ")",
                        h(PreactTooltip, { class: "btn btn-link u-p0 u-text-decoration-none", title: `${translate(t.theme_defaults.delivery.info.cost)}${restaurant.deliveryCost}, ${translate(t.theme_defaults.delivery.info.min_order_value)}${restaurant.minOrderValue}${freeTresholdString}` },
                            h("span", { className: "icon-info-sign icon-flex-center", "aria-label": translate(t.theme_defaults.theme.show_more) })))))),
            doesRestaurantDeliver === false && (h(NoWithinAreaAlert, { onEdit: onEdit })),
            h("div", null,
                h("a", { href: restaurant.menuLink, className: "m-restaurants__card-action btn btn-primary" }, translate(t.restaurants.select.button_select))))));
}
function NoWithinAreaAlert(props) {
    const { onEdit } = props;
    return (h(Fragment, null,
        h(Alert, { type: "warning", message: translate(t.delivery.not_possible, {
                address: deliveryAddress,
            }), link: {
                label: `(${translate(t.restaurants.select.button_change)})`,
                path: "#" + searchFormId,
                onClick: onEdit
                    ? (e) => {
                        e.preventDefault();
                        onEdit();
                    }
                    : undefined,
            } })));
}
export default renderPreact("RestaurantSelection", RestaurantSelection);
